import { render } from "./HolidayTable.vue?vue&type=template&id=77d9f808"
import script from "./HolidayTable.vue?vue&type=script&lang=js"
export * from "./HolidayTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__